module.exports = __webpack_public_path__ + "imgascvts/xiehe.95815e1a.png";